// extracted by mini-css-extract-plugin
export var accesDirectContainer = "acces-direct-module--acces-direct-container--4b74b";
export var accesDirectDescription = "acces-direct-module--acces-direct-description--90988";
export var accesDirectHeader = "acces-direct-module--acces-direct-header--9512a";
export var accesDirectItem = "acces-direct-module--acces-direct-item--aa9a0";
export var accesDirectItemDescription = "acces-direct-module--acces-direct-item-description--290dd";
export var accesDirectItemImg = "acces-direct-module--acces-direct-item-img--9a77a";
export var accesDirectTitle = "acces-direct-module--acces-direct-title--82fa6";
export var closeButton = "acces-direct-module--close-button--d96be";
export var editButton = "acces-direct-module--edit-button--a0b1e";
export var editButtonTitle = "acces-direct-module--edit-button-title--a9883";